//eslint-disable
import React, { Component, Fragment } from 'react';
import { InputField } from './InputField';
import { InputLookup } from './InputLookup';
import { PersonSelect } from './PersonSelect';
import { PetSelect } from './PetSelect';

export class FieldEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Fragment>
                {(this.props.field.FieldType === 'select')
                    ? <InputLookup
                        label={this.props.field.FieldLabel}
                        fieldname={this.props.field.FieldName}
                        regularExpression={this.props.field.Validation}
                        mandatory={this.props.field.IsMandatory}
                        warnText='Invalid selection'
                        value={this.props.field.Value}
                        listName={this.props.field.Validation}
                        onUpdate={this.props.onUpdate.bind(this)}
                        fieldValid={this.props.field.IsValid}
                        inline={this.props.inline}
                        canClear={this.props.canClear} 
                    />
                    : (this.props.field.FieldType === 'petSelect')
                        ? <PetSelect label={this.props.field.FieldLabel}
                            fieldname={this.props.field.FieldName}
                            regularExpression={this.props.field.Validation}
                            warnText='Invalid format'
                            mandatory={this.props.field.IsMandatory}
                            pets={this.props.field.Value}
                            onUpdate={this.props.onUpdate.bind(this)}
                            inline={this.props.inline}
                            fieldValid={this.props.field.IsValid}
                            canClear={this.props.canClear} />
                        : (this.props.field.FieldType === 'personSelect')
                            ? <PersonSelect type='Walker' label={this.props.field.FieldLabel}
                                fieldname={this.props.field.FieldName}
                                regularExpression={this.props.field.Validation}
                                warnText='Invalid format'
                                mandatory={this.props.field.IsMandatory}
                                value={this.props.field.Value}
                                onUpdate={this.props.onUpdate.bind(this)}
                                inline={this.props.inline}
                                fieldValid={this.props.field.IsValid}
                                canClear={this.props.canClear} />
                            : <InputField
                                label={this.props.field.FieldLabel}
                                fieldname={this.props.field.FieldName}
                                regularExpression={this.props.field.Validation}
                                warnText='Invalid format'
                                fieldType={this.props.field.FieldType}
                                mandatory={this.props.field.IsMandatory}
                                value={this.props.field.Value}
                                inline={this.props.inline}
                                onUpdate={this.props.onUpdate.bind(this)}
                                fieldValid={this.props.field.IsValid} />
                }
            </Fragment>
        );
    }
}